import styled from 'styled-components'

const VIEWPORT = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
}

type StickyNavContainerProp = {
  visible
}

export const StickyNavContainer = styled.div.attrs({
  className: 'stickyNavContainer',
  role: 'Sticky',
})<StickyNavContainerProp>`
  display: ${(props) => (props.visible ? 'block' : 'none')};
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: ${(props) => (props.visible ? 'flex' : 'none')};
  }
`

export const StickyCartContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
`
type VisibilityProps = {
  visibility
}

export const StickyHeaderContainer = styled.div<VisibilityProps>`
  display: ${(props) => (props.visibility ? 'block' : 'none')};
  width: 55%;

  @media only screen and (max-width: ${VIEWPORT.lg}) {
    order: 1;
    width: 100%;
  }
`

export const PlanSectionContainer = styled.div<VisibilityProps>`
  display: ${(props) => (props.visibility ? 'block' : 'none')};
  width: 60%;

  @media only screen and (max-width: ${VIEWPORT.lg}) {
    order: 3;
    width: 100%;
  }
`

export const CartContainer = styled.div<VisibilityProps>`
  display: ${(props) => (props.visibility ? 'flex' : 'none')};
  width: 40%;
  align-self: flex-end;
  height: 100%;
  position: absolute;
  top: 0;

  @media only screen and (max-width: ${VIEWPORT.lg}) {
    order: 2;
    width: 100%;
    position: static;
  }
`
export const CartComponent = styled.div`
  height: 100%;
  width: 100%;
`
